import { combineReducers } from 'redux';

import { salesReportReducer } from './reducers/salesReport';

export const statisticsReducer = combineReducers({
  salesReport: salesReportReducer,
});
